export default "__VITE_ASSET__3b9ea04b__"